module.exports = __webpack_public_path__ + "img/xianjin.e71e2903.png";